module.exports = __webpack_public_path__ + "static/media/smileSmallKTM.8c03aaa0.svg";